export const environment = {
  name: "production",
  stage: "prod",
  apiBaseUrl: "https://api.legal.xonboard.io",
};
